import React from "react";
import PropTypes from "prop-types";

import Header from "../Header";
import Footer from "../Footer";

/**
 * ToolLayout
 *
 * Shared page-level layout for all independent tools.
 * This component is responsible for:
 * - Rendering the global site header and footer
 * - Providing consistent page spacing and structure
 * - Serving as the SEO-friendly wrapper for each tool page
 *
 * Tools themselves should remain UI-only and unaware of layout concerns.
 */
const ToolLayout = ({ title, description, children }) => {
  return (
    <>
      {/* =========================
          Global Header
         ========================= */}
      <Header />

      {/* =========================
          Tool Page Container
         ========================= */}
      <main className="tool-page">
        <div className="tool-page-inner">
          

          {/* =========================
              Tool Content
             ========================= */}
          <section className="tool-page-content">
            {children}
          </section>
        </div>
      </main>

      {/* =========================
          Global Footer
         ========================= */}
      <Footer />
    </>
  );
};

ToolLayout.propTypes = {
  title: PropTypes.string,
  description: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export default ToolLayout;
